import { cn } from "@/lib/cn";
import type { Step } from "@/store/steps";

type Props = {
    steps: Step[];
    currentStepIndex: number;
    ariaLabel: string;
};

export function StepIndicator({ steps, currentStepIndex, ariaLabel }: Props) {
    return (
        <nav
            aria-label={ariaLabel}
            className="flex items-center justify-center gap-0"
        >
            {steps.map((step, index) => {
                const isCompleted = index < currentStepIndex;
                const isActive = index === currentStepIndex;

                return (
                    <div key={step.id} className="flex items-center">
                        <div
                            className="flex items-center gap-2"
                            data-testid={`step-indicator-${step.id}`}
                        >
                            <div
                                className={cn(
                                    "size-7 rounded-full flex items-center justify-center text-sm font-semibold border-2 transition-colors shrink-0",
                                    isActive && "border-primary text-primary",
                                    isCompleted &&
                                        "bg-primary border-primary text-contrast-text",
                                    !isActive &&
                                        !isCompleted &&
                                        "border-gray-300 text-gray-400",
                                )}
                            >
                                {index + 1}
                            </div>
                            <span
                                className={cn(
                                    "text-sm font-medium",
                                    isActive
                                        ? "text-gray-900 font-semibold"
                                        : "hidden sm:inline",
                                    isCompleted && "text-gray-600",
                                    !isActive &&
                                        !isCompleted &&
                                        "text-gray-400",
                                )}
                            >
                                {step.label}
                            </span>
                        </div>

                        {index < steps.length - 1 && (
                            <div
                                className={cn(
                                    "h-px w-4 sm:w-8 mx-2 sm:mx-3",
                                    isCompleted ? "bg-primary" : "bg-gray-300",
                                )}
                            />
                        )}
                    </div>
                );
            })}
        </nav>
    );
}
